import React, { useEffect, useRef } from 'react'
import './Locationnotsupport.css'
import { iconwrapper } from '../../../../config/commonfunctions'
import { MAIN_VENDOR_ICON,MAIN_PRICELIST_ICON } from '../../../../config/svgicons'

function Locationnotsupport({ from }) {
    const ringRef = useRef(null)

    useEffect(() => {
        const ring = ringRef.current
        if (ring) {
            ring.classList.add('animate')
        }
    }, [])

    return (
        <div className="Locationnotsupport_root">
            <div className="Locationnotsupport_card">

                <div className="Locationnotsupport_icon_wrap" ref={ringRef}>
                    <div className="Locationnotsupport_icon_circle">
                        {iconwrapper(
                            from === 'PRICELIST'
                                ? MAIN_PRICELIST_ICON
                                : from === 'WEDDINGVENDORS'
                                    ? MAIN_VENDOR_ICON
                                    : null,
                            {width: 30, height: 30, display: 'flex', placeContent: 'center'}
                            )}
                    </div>
                </div>

                <div className="Locationnotsupport_title">
                    {from === 'PRICELIST'
                        ? 'No pricelist found.'
                        : from === 'WEDDINGVENDORS'
                            ? 'No vendors found.'
                            : null}

                </div>
            </div>
        </div>
    )
}

export default Locationnotsupport